import { createApp, h } from 'vue';
import { COMPONENTS } from './const';
/**
 * 创建vue组件
 * @param param0
 */
export function useCreateVueApp({ key, props, componentKey, el, slots, vueAppInstances, extParam, }) {
    const component = COMPONENTS[componentKey];
    if (vueAppInstances[key]) {
        return;
    }
    vueAppInstances[key] = createApp({
        render() {
            return h(component, { ...props }, { ...slots });
        },
    });
    vueAppInstances[key].destroy = () => {
        vueAppInstances[key]?.unmount();
        vueAppInstances[key] = null;
    };
    vueAppInstances[key].config.globalProperties.$props = extParam;
    vueAppInstances[key].mount(el);
}
